import { ACTIONBUTTON_LOCALSTORAGE_KEY } from './constants';
import { ActionButtonExps } from './reducer';
import { fromPredicate } from 'fp-ts/lib/Option';
import storage from 'local-storage-fallback';

const initialize = (): ActionButtonExps => {
    return fromPredicate<string>(Boolean)(storage.getItem(ACTIONBUTTON_LOCALSTORAGE_KEY))
        .map(se => JSON.parse(se))
        .getOrElse({});
};
export default initialize;
